'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _STR_EMPTY = require('permanent/es/STR_EMPTY');

var _STR_EMPTY2 = _interopRequireDefault(_STR_EMPTY);

var _INT_TWO = require('./_constants/INT_TWO');

var _INT_TWO2 = _interopRequireDefault(_INT_TWO);

var _and = require('./and');

var _and2 = _interopRequireDefault(_and);

var _call = require('./call');

var _call2 = _interopRequireDefault(_call);

var _compose = require('./compose');

var _compose2 = _interopRequireDefault(_compose);

var _define = require('./define');

var _define2 = _interopRequireDefault(_define);

var _executeWith = require('./executeWith');

var _executeWith2 = _interopRequireDefault(_executeWith);

var _getProp = require('./getProp');

var _getProp2 = _interopRequireDefault(_getProp);

var _isArray = require('./isArray');

var _isArray2 = _interopRequireDefault(_isArray);

var _isNumber = require('./isNumber');

var _isNumber2 = _interopRequireDefault(_isNumber);

var _isString = require('./isString');

var _isString2 = _interopRequireDefault(_isString);

var _orWith = require('./orWith');

var _orWith2 = _interopRequireDefault(_orWith);

var _spread = require('./spread');

var _spread2 = _interopRequireDefault(_spread);

var _ternaryWith = require('./ternaryWith');

var _ternaryWith2 = _interopRequireDefault(_ternaryWith);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns copy of entry or character at given index in string or array
 *
 * @module at
 * @func
 * @since 1.5.0
 * @param {number} index
 * @param {Array|string} val
 * @return {*}
 * @Example
 *
 *     at(2, 'foo'); //=> 'o'
 *     at(1)([0, 1, 2]); //=> 1
 */

var isStringOrArray = (0, _orWith2.default)([_isString2.default, _isArray2.default]);
var checkArgs = (0, _executeWith2.default)(_and2.default, _isNumber2.default, isStringOrArray);
var callCheckArgs = (0, _call2.default)(checkArgs);
var callGetProp = (0, _call2.default)(_getProp2.default);
var getValue = (0, _ternaryWith2.default)(_STR_EMPTY2.default, callGetProp, callCheckArgs);
var internal = (0, _compose2.default)(getValue, _spread2.default);

var at = (0, _define2.default)(internal, _INT_TWO2.default);

exports.default = at;